import Environment from '../models/environment.model';

const isLiveB = window.location.origin?.includes('reports.liveb');
const LiveAU: Environment = {
  region: 'au',
  env: 'live',
  timezone: 'Australia/Sydney',
  leapAuth: {
    clientId: 'LSANDMMWVAL4LGCH',
    oauthEndpoint: 'https://login.leap365.com.au',
    providerId: 'leap',
    userInfoUri: '/api/userinfo',
    authAgentUrl: 'https://cdn.test.leap.com.au/leap_auth/auth_agent/2.0.1/index.umd.js',
  },
  title: 'this is live au',
  reportingEndpoint: isLiveB ? 'https://reporting-api-liveb.leapaws.com.au' : 'https://reporting-api.leapaws.com.au',
  reportingServiceEndpoint: isLiveB
    ? 'https://reporting-services-api.liveb.leapaws.com.au'
    : 'https://reporting-services-api.leapaws.com.au',

  helpCenterUrl: 'https://community.leap.com.au/s/',
  powerBILink: 'https://community.leap.com.au/s/article/Installing-Power-BI-LEAP-Connector-AU',
  articleLinks: [
    {
      label: 'Available LEAP Reports',
      link: 'https://community.leap.com.au/s/article/Available-LEAP-reports',
    },
    {
      label: 'About LEAP Reports',
      link: 'https://community.leap.com.au/s/article/About-LEAP-Reports',
    },
    {
      label: '10 Essential LEAP Reports',
      link: 'https://community.leap.com.au/s/article/10-Essential-LEAP-Reports-AU',
    },
    {
      label: 'A Guide on Invoice-Related Reports',
      link: 'https://community.leap.com.au/s/article/A-Guide-on-Invoices-Related-Reports-AU',
    },
    {
      label: 'LEAP Reports - FAQs',
      link: 'https://community.leap.com.au/s/article/LEAP-Reports-FAQs-AU',
    },
  ],
};

export default LiveAU;
